import React, {useState} from 'react';
import {injectIntl} from 'react-intl';
import GenericModal, {MODAL_WIDTH} from './generic_modal';
import {IFrameWrapper} from './WhatIsNewModal_styled';
import InlineLoader from '../../forecast-app/shared/components/inline-loader/inline_loader';

const WhatIsNewModal = ({intl, closeModal}) => {
	const [loadingWhatIsNew, setLoadingWhatIsNew] = useState(true);

	const Content = (
		<div>
			{loadingWhatIsNew && <InlineLoader />}
			<IFrameWrapper
				onLoad={() => setLoadingWhatIsNew(false)}
				isLoading={loadingWhatIsNew}
				src="https://websitepreview.forecast.app/whats-new"
			/>
		</div>
	);

	return (
		<GenericModal
			closeModal={closeModal}
			content={Content}
			headerText={intl.formatMessage({id: 'header.what_is_new'})}
			modalWidth={MODAL_WIDTH.MEDIUM_LARGE}
		></GenericModal>
	);
};

export default injectIntl(WhatIsNewModal);
